<app-summary-field [iconName]="iconName" [textColor]="textColor" [label]="label" [value]="lovValueSummary ? lovValueSummary.label : '/'">
</app-summary-field>
